import { FieldValues, UseFormReturn } from "react-hook-form";
import { useEffect, useRef } from "react";

export function useFormAutosave<T extends FieldValues>(
  form: UseFormReturn<T>,
  onSave: () => void,
  interval: number = 180000,
) {
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      const isDirty =
        form.formState.isDirty &&
        Object.keys(form.formState.dirtyFields).length > 0;

      if (isDirty) {
        onSave();
      }
    }, interval);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval, onSave]);

  return null;
}
